import * as React from 'react';
export const IcPayRecurring = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.5 9a1 1 0 00-1-1h-5a1 1 0 000 2h2a1 1 0 110 2h-1a1 1 0 00-.45 1.89l4 2a.931.931 0 00.45.11 1 1 0 00.89-.55 1 1 0 00-.39-1.34l-1.56-.78a3 3 0 00.88-3.33h.18a1 1 0 001-1zM12 2A10 10 0 002 12c-.002.374.021.749.07 1.12a1.007 1.007 0 002-.24A8.493 8.493 0 014 12a8 8 0 112.73 6h.77a1 1 0 000-2h-3a1 1 0 00-1 1v3a1 1 0 002 0v-.43A10 10 0 1012 2z'
      fill='currentColor'
    />
  </svg>
);
